var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",class:{ 'skeleton-loading': _vm.loading }},_vm._l((9),function(item,i){return _c('v-skeleton-loader',{key:i,ref:"skeleton",refInFor:true,staticClass:"homeEvents_skeleton",attrs:{"type":"image, paragraph"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }